<template>
  <div class="rounded-full px-[5px] py-[2px] text-[10px] leading-[10px]">
    <slot />
  </div>
</template>
